import {Injectable} from "@angular/core";
import {Query} from "apollo-angular";
import {Food} from "../../../../api/graphql";
import gql from 'graphql-tag'
interface Response {
    getFoods: Food[]
}

@Injectable({
    providedIn: 'root'
})
export class GetFoodsQuery extends Query<Response> {
    document = gql`
        query  {
            getFoods {
                id
                name
                price
                category {
                    id
                    name
                    description
                }
                description
                type
                registeredAt
                images {
                    id
                    name
                    url
                }
            }
        }
    `
}
